import React, {Fragment} from 'react';
import {Button, Container, Form, Message} from "semantic-ui-react";
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {loginAction, logoutAction, openForgotPasswordModal} from "./actions";
import {isFalsy, isTruthy} from "../../utils/DBUtils";

class LoginForm extends React.Component {

    componentDidMount() {
        if (isFalsy(this.props.accessToken)) {

        }
    }

    login(event) {
        event.stopPropagation();
        event.preventDefault();

        let username = event.target.username.value;
        let password = event.target.password.value;

        this.props.login(username, password);
    }

    render() {

        if (this.props.accessToken) {
            return <Redirect to="/" />
        }

        return (
          <Fragment>
            <Form onSubmit={(event) => this.login(event)} error={isTruthy(this.props.errorMessage)}>
                <Form.Input label="Username" name="username" />
                <Form.Input label="Password" name="password" type="password" />
                <Message error={true} className={isTruthy(this.props.errorMessage) ? "fadeInUp animResponse": ""}>
                    Login failed: {this.props.errorMessage}
                </Message>
                <div className="login-buttons">
                  <Button type="submit" primary>Login</Button>
                  {/* <a className="item" onClick={this.props.forgotPassword}>Forgot Password</a> */}
                </div>

            </Form>

          </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    accessToken: state.user.accessToken,
    username: "User",
    errorMessage: state.user.loginErrorMessage,
    user: state.user.user
});

const mapDispatchToProps = (dispatch) => ({
    login: (username, password) => dispatch(loginAction(username, password)),
    logout: () => dispatch(logoutAction()),
    forgotPassword: () => dispatch(openForgotPasswordModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./public/pages/Login/LoginForm.jsx